import React from 'react';

function Results({ result }) {
  const { monthlyPayment, breakEvenMonth } = result;

  const formatMonthToYears = (month) => {
    const years = Math.floor(month / 12);
    const months = month % 12;
    return `${years} an(s) et ${months} mois`;
  };

  return (
    <div className="bg-white p-6 rounded shadow my-4">
      <h2 className="text-xl font-bold mb-4">Résultats de la simulation</h2>
      <p>
        <span className="font-semibold">Paiement mensuel du prêt :</span> {monthlyPayment.toFixed(2)} €
      </p>
      {breakEvenMonth ? (
        <p className="mt-2 text-green-600 font-bold">
          L'achat devient rentable après {formatMonthToYears(breakEvenMonth)} ({breakEvenMonth} mois)
        </p>
      ) : (
        <p className="mt-2 text-red-600 font-bold">
          Le break-even n'a pas été atteint dans la période simulée.
        </p>
      )}
    </div>
  );
}

export default Results; 